export const SET_PAGE_INFO = 'SET_PAGE_INFO'

export function setPageInfo(pageInfo) {
  return {
    type: SET_PAGE_INFO,
    pageInfo
  }
}



// WEBPACK FOOTER //
// ./src/actions/pageInfo.js